import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface DataCoverageInfoProps {
  startDate: Date | null;
  endDate: Date | null;
  coverage: number;
  totalDays: number;
  missingDays: number;
}

export const DataCoverageInfo: React.FC<DataCoverageInfoProps> = ({
  startDate,
  endDate,
  coverage,
  totalDays,
  missingDays
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-4 gap-4 mb-6">
      <div className="bg-swiss-pearl p-3 rounded-lg">
        <p className="text-xs text-swiss-stone mb-1">{t('dataAlignment.coverage.period')}</p>
        <p className="text-sm font-medium">
          {startDate && endDate
            ? `${format(startDate, 'MMM dd, yyyy')} - ${format(endDate, 'MMM dd, yyyy')}`
            : t('dataAlignment.coverage.noData')}
        </p>
      </div>
      <div className="bg-swiss-pearl p-3 rounded-lg">
        <p className="text-xs text-swiss-stone mb-1">{t('dataAlignment.coverage.coverage')}</p>
        <p className="text-sm font-medium">{coverage.toFixed(1)}%</p>
      </div>
      <div className="bg-swiss-pearl p-3 rounded-lg">
        <p className="text-xs text-swiss-stone mb-1">{t('dataAlignment.coverage.totalDays')}</p>
        <p className="text-sm font-medium">{totalDays}</p>
      </div>
      <div className="bg-swiss-pearl p-3 rounded-lg">
        <p className="text-xs text-swiss-stone mb-1">{t('dataAlignment.coverage.missingDays')}</p>
        <p className="text-sm font-medium">{missingDays}</p>
      </div>
    </div>
  );
};